import BlockOption from "./BlockOption";
import { OPTION_MAP } from "./constants";
import { generatePlaceholder } from "./utils";

const OptionField = ({
  option,
  editable,
  dragHandleProps,
  draggableProps,
  handleDeleteClick,
  handleCloneClick,
  hideDeleteOption,
  hideCloneOption,
  innerRef,
  onEdit,
  draggable,
  disabled,
  isCheckboxEnabled,
  isPictureChoice,
  isTextArea,
  isMultiInput,
  isEditor,
  inputConfig,
  shouldFocus,
  isEditable,
  itemLabel,
  handleChange,
  handleKeyDown,
  name,
  optionIndex,
  onBlur,
  arrayHelpers,
}) => {
  const commonProps = {
    id: option.id,
    arrayHelpers,
    dragHandleProps,
    draggableProps,
    hideCloneOption,
    hideDeleteOption,
    innerRef,
    isCheckboxEnabled,
    name,
    optionIndex,
    isDraggable: draggable && !disabled,
    onClone: handleCloneClick,
  };

  const Component =
    (isMultiInput && OPTION_MAP.multiInput) ||
    (isPictureChoice && OPTION_MAP.pictureChoice) ||
    (isEditor && OPTION_MAP.editor) ||
    OPTION_MAP.input;

  const placeholder = generatePlaceholder(itemLabel, optionIndex);

  return editable ? (
    <Component
      {...{
        ...commonProps,
        inputConfig,
        isEditor,
        isTextArea,
        onBlur,
        option,
        placeholder,
        shouldFocus,
      }}
      disabled={!isEditable || disabled}
      onChange={handleChange}
      onDelete={handleDeleteClick}
      onKeyDown={handleKeyDown}
    />
  ) : (
    <BlockOption
      {...{ ...commonProps, handleDeleteClick, onEdit, placeholder }}
      label={option.label}
    />
  );
};

export default OptionField;
